import { Container, Divider } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import CheckIcon from "@mui/icons-material/Check";

export const ApiPlans = () => {
  return (
    <>
      <Container className="container-xxl">
        <div className="row justify-content-between align-items-center mb-12">
          <div className="col-12"></div>
          <div className="col-lg-5 text-center text-lg-start">
            <div className="text-cap fw-medium text-primary mb-2">
              UPCX BlockExplorer API
            </div>
            <h1 className="h2 fw-bold">
              Build Precise &amp; Reliable Apps with{" "}
              <span className="text-primary">UPCX BlockExplorer APIs</span>
            </h1>
            <p className="fs-base">
              Data from the leading Ethereum Block Explorer catered to your
              needs.
            </p>
            <div className="d-flex justify-content-center justify-content-lg-start align-items-center gap-4">
              <a className="btn btn-primary py-2 px-4" href="#pricing-plan">
                API Pricing Plans
              </a>
              <a
                className="group"
                target="_blank"
                href="https://explorer.upcx.org:5000/api/"
              >
                API Documentation{" "}
                <LaunchIcon
                  className="far fa-arrow-up-right text-secondary group-hover transition-all ms-1"
                  sx={{ width: "15px", height: "15px" }}
                />
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="d-none d-lg-flex justify-content-end m-10">
              <img
                width="520"
                src="/assets/img/api-hero.png"
                className="img-fluid"
                alt="api-main"
              />
            </div>
          </div>
        </div>
        <div
          className="row justify-content-center text-center mb-6"
          id="pricing-plan"
        >
          <div className="col-sm-10 col-lg-8 col-xl-6">
            <h2 className="h4">Ready to get started?</h2>
            <p className="fs-base">
              Select the plan that best suits you or contact us for a custom
              option.
            </p>
            <div className="d-flex justify-content-center">
              <ul
                className="nav nav-pills nav-pills-alt bg-light border rounded-pill flex-fill flex-grow-0 gap-2 p-1"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link rounded-5 w-100 active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    Monthly
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link rounded-5 w-100"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    Quarterly{" "}
                    <span className="small opacity-75 ms-1">(10% Off)</span>
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link rounded-5 w-100"
                    id="pills-contact-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-contact"
                    type="button"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                  >
                    Yearly{" "}
                    <span className="small opacity-75 ms-1">(15% Off)</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-5 g-4">
          <div className="col">
            <div className="card h-100">
              <div className="p-4">
                <div className="text-cap fw-medium text-primary mb-1">Free</div>
                <h4 className="mb-0">$0</h4>
                <span className="small text-muted mb-1">
                  *Attribution required
                </span>
              </div>
              <Divider className="my-0" />
              <div className="card-body d-flex flex-column justify-content-between">
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>5 call/second limit</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Up to 100,000 API calls/day</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>All existing community endpoints</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Community support</span>
                  </li>
                </ul>
                <button
                  // href="/myapikey"
                  className="btn btn-primary py-2 px-8 w-100"
                  type="button"
                  disabled
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="pt-4 px-4" style={{ paddingBottom: "2.4rem" }}>
                <div className="text-cap fw-medium text-primary mb-1">
                  Standard
                </div>
                <h4 className="mb-0">
                  $199<span className="fs-6 text-muted fw-normal">/mo</span>
                </h4>
              </div>
              <Divider className="my-0" />
              <div className="card-body d-flex flex-column justify-content-between">
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>10 calls/second limit</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Up to 200,000 API calls/day</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>All existing community endpoints</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>
                      Access to{" "}
                      <a href="#" target="_blank">
                        API Pro endpoints
                      </a>
                    </span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Escalated support</span>
                  </li>
                </ul>
                <button
                  // href="/myapikey"
                  className="btn btn-primary py-2 px-8 w-100"
                  type="button"
                  disabled
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="pt-4 px-4" style={{ paddingBottom: "2.4rem" }}>
                <div className="text-cap fw-medium text-primary mb-1">
                  Advanced
                </div>
                <h4 className="mb-0">
                  $299<span className="fs-6 text-muted fw-normal">/mo</span>
                </h4>
              </div>
              <Divider className="my-0" />
              <div className="card-body d-flex flex-column justify-content-between">
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>20 calls/second limit</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Up to 500,000 API calls/day</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>All existing community endpoints</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>
                      Access to{" "}
                      <a href="#" target="_blank">
                        API Pro endpoints
                      </a>
                    </span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Escalated support</span>
                  </li>
                </ul>
                <button
                  // href="/myapikey"
                  className="btn btn-primary py-2 px-8 w-100"
                  type="button"
                  disabled
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="pt-4 px-4" style={{ paddingBottom: "2.4rem" }}>
                <div className="text-cap fw-medium text-primary mb-1">
                  PROFESSIONAL
                </div>
                <h4 className="mb-0">
                  $399<span className="fs-6 text-muted fw-normal">/mo</span>
                </h4>
              </div>
              <Divider className="my-0" />
              <div className="card-body d-flex flex-column justify-content-between">
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>30 calls/second limit</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Up to 1,000,000 API calls/day</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>All existing community endpoints</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>
                      Access to{" "}
                      <a href="#" target="_blank">
                        API Pro endpoints
                      </a>
                    </span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Escalated support</span>
                  </li>
                </ul>
                <button
                  // href="/myapikey"
                  className="btn btn-primary py-2 px-8 w-100"
                  type="button"
                  disabled
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="pt-4 px-4" style={{ paddingBottom: "2.4rem" }}>
                <div className="text-cap fw-medium text-primary mb-1">
                  Pro Plus
                </div>
                <h4 className="mb-0">
                  $899<span className="fs-6 text-muted fw-normal">/mo</span>
                </h4>
              </div>
              <Divider className="my-0" />
              <div className="card-body d-flex flex-column justify-content-between">
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>30 calls/second limit</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Up to 1,500,000 API calls/day</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>All existing community endpoints</span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>
                      Access to{" "}
                      <a href="#" target="_blank">
                        API Pro endpoints
                      </a>
                    </span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>
                      Access to{" "}
                      <a href="#" target="_blank">
                        Address Metadata endpoint
                      </a>
                    </span>
                  </li>
                  <li className="fs-6 d-flex align-items-baseline">
                    <CheckIcon
                      className="fa-regular fa-check me-1"
                      sx={{ width: "20px", height: "20px", my: "auto" }}
                    />
                    <span>Escalated support</span>
                  </li>
                </ul>
                <div className="text-muted small mb-2">
                  *Limited to <strong className="fw-medium">ONE</strong> app
                  license.
                </div>
                <button
                  // href="/myapikey"
                  className="btn btn-primary py-2 px-8 w-100"
                  type="button"
                  disabled
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};
